module.exports = __webpack_public_path__ + "img/cryptlogo.b3287507.svg";